import React, { useState } from "react";
import Section from "Section";
import Title from "../components/Title";
import FAQQNA from "./FAQ_text";
import SUPERMAN_RUHACKS from "./media/superman.png";
import BACKGROUND from "./media/bg.png";

export default function FAQ() {
  return (
    <Section
      bcolor="#202934"
      BG={
        <div className="faq-bg">
          <img src={BACKGROUND} alt=""></img>
        </div>
      }
    >
      <div className="faq-anchor" id="faq" />
      <div className="faq-title">
        <div className="faq-title__tit">
          <Title text="Frequently Asked Questions" />
        </div>
        <img src={SUPERMAN_RUHACKS} alt="" className="faq-title__image" />
      </div>
      <div className="faq-qna__con">
        {FAQQNA.map((p) => (
          <QNA {...p} />
        ))}
      </div>
      <div className="faq-more">
        <div className="faq-more__ques">Still have questions?</div>
        <div className="faq-more__ans">
          Reach out to us at communications@ruhacks.com or our social media, and
          we’ll get back to you ASAP!
        </div>
      </div>
    </Section>
  );
}

function QNA({ q, a }) {
  const [open, setOpen] = useState(0);
  return (
    <div
      className="faq-qna"
      onClick={() => setOpen(!open)}
      style={open ? {} : {}}
    >
      <div className={`faq-qna__q ${open ? "open" : "close"}`}>
        <div className="faq-qna__q-plus">
          <div className="plus" style={open ? { height: 0 } : {}}></div>
          <div className="minus"></div>
        </div>
        <div className="faq-qna__q-text">{q}</div>
      </div>
      <div className={`faq-qna__a ${open ? "open" : "close"}`}>{a}</div>
    </div>
  );
}
